const elObserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add('enter');
			elObserver.unobserve(entry.target)
		}
	})
});


export default {
	bind(el) {
		el.classList.add('before-enter');
		elObserver.observe(el);
	}
}
